// BookingPage (işletme randevu + demo) için hafif i18n — varsayılan TR, seçim localStorage'da saklanır.
import React from "react";
import { tr, enGB, de } from "date-fns/locale";
import { cn } from "@/lib/utils";

export const LANG_KEY = "rez_lang";
export const getStoredLang = () => {
  try {
    const v = localStorage.getItem(LANG_KEY);
    if (v === "en" || v === "de" || v === "tr") return v;
    // İlk ziyaret: tarayıcı dili EN/DE ise otomatik o dilde aç, değilse TR
    const nav = (navigator.language || "").slice(0, 2).toLowerCase();
    return nav === "en" || nav === "de" ? nav : "tr";
  } catch { return "tr"; }
};
export const setStoredLang = (l) => { try { localStorage.setItem(LANG_KEY, l); } catch { /* ignore */ } };

export const DF_LOCALE = { tr, en: enGB, de };
export const DATE_LOCALE = { tr: "tr-TR", en: "en-GB", de: "de-DE" };

export const DICT = {
  tr: {
    stepService: "Hizmet", stepStaff: "Personel", stepDate: "Tarih", stepTime: "Saat", stepInfo: "Bilgiler",
    chooseService: "Hizmet seçin", noServices: "Bu işletme henüz hizmet eklememiş.", min: "dk",
    chooseStaff: "Personel seçin", anyStaff: "Farketmez", anyStaffDesc: "Uygun olan ilk personel",
    chooseDate: "Tarih seçin", chooseTime: "Saat seçin",
    noSlots: "Bu tarih için müsait saat bulunmuyor. Lütfen başka bir tarih seçin.",
    yourInfo: "Bilgileriniz", serviceLabel: "Hizmet", staffLabel: "Personel", dateLabel: "Tarih",
    timeLabel: "Saat", priceLabel: "Ücret",
    nameLabel: "Ad Soyad", namePlaceholder: "Adınız Soyadınız",
    phoneLabel: "Telefon Numarası", phonePlaceholder: "05xx xxx xx xx",
    phoneHint: "WhatsApp onay mesajı için telefon numaranızı doğru girin.",
    phoneWarning: "Telefon numarası 11 rakam olmalı. WhatsApp onay mesajı için telefon numaranızı doğru girin.",
    back: "Geri", next: "Devam Et", confirm: "Rezervasyonu Onayla",
    successTitle: "Rezervasyonunuz Alındı!", successWaiting: "sizi bekliyor.",
    nameRow: "Ad Soyad", locationLabel: "Konum", directions: "Yol Tarifi Al (Google Haritalar)",
    manageBooking: "Randevumu Yönet (İptal / Ertele)", confirmSms: "Onay mesajı telefonunuza gönderilecektir.",
    newBooking: "Yeni Rezervasyon", demoCta: "Ana Sayfaya Dön ve Üye Ol",
    poweredBy: "365Rez ile çalışır — siz de ücretsiz başlayın",
    demoBanner: "Bu bir demo rezervasyon sayfasıdır", demoBannerShort: "Demo sayfası",
    home: "Ana Sayfa", register: "Üye Ol",
    notAvailableTitle: "Şu anda randevu alınamıyor",
    notAvailableDesc: "Bu işletme şu anda online randevu kabul etmiyor. Lütfen daha sonra tekrar deneyin.",
    notFoundTitle: "İşletme bulunamadı", notFoundDesc: "Bu rezervasyon linki geçersiz olabilir.",
    phoneToast: "Telefon numarası 11 rakam olmalı.",
    manageTitle: "Randevunuz", manageNotFound: "Randevu bulunamadı",
    manageNotFoundDesc: "Bu bağlantı geçersiz veya süresi dolmuş olabilir.",
    statusPending: "Beklemede", statusConfirmed: "Onaylandı", statusCompleted: "Tamamlandı", statusCancelled: "İptal Edildi",
    cancelledNote: "Bu randevu iptal edilmiştir.", pastNote: "Geçmiş randevular değiştirilemez.",
    pickNewDate: "Yeni tarih seçin", pickTimeSuffix: "— saat seçin", noSlotsManage: "Bu tarih için müsait saat yok.",
    giveUp: "Vazgeç", doReschedule: "Ertele", startReschedule: "Randevuyu Ertele", cancelBooking: "Randevuyu İptal Et",
    cancelTitle: "Randevunuzu iptal etmek istiyor musunuz?",
    cancelDesc: "Bu işlem geri alınamaz. İptal edilen randevu yeniden aktifleştirilemez, yeni bir randevu oluşturmanız gerekir.",
    cancelYes: "Evet, İptal Et", cancelToast: "Randevunuz iptal edildi", rescheduleToast: "Randevunuz ertelendi",
    motto: "7 Gün 24 Saat 365 Gün Rezervasyon",
    otpTitle: "Telefonunuzu doğrulayın", otpDesc: "WhatsApp ile gönderdiğimiz 6 haneli kodu girin:",
    otpVerify: "Doğrula ve Devam Et", otpResend: "Kodu tekrar gönder", otpCancel: "Vazgeç",
    otpSent: "Doğrulama kodu WhatsApp'tan gönderildi",
  },
  en: {
    stepService: "Service", stepStaff: "Staff", stepDate: "Date", stepTime: "Time", stepInfo: "Details",
    chooseService: "Choose a service", noServices: "This business hasn't added any services yet.", min: "min",
    chooseStaff: "Choose a staff member", anyStaff: "Any staff", anyStaffDesc: "First available staff member",
    chooseDate: "Choose a date", chooseTime: "Choose a time",
    noSlots: "No available times for this date. Please choose another date.",
    yourInfo: "Your details", serviceLabel: "Service", staffLabel: "Staff", dateLabel: "Date",
    timeLabel: "Time", priceLabel: "Price",
    nameLabel: "Full name", namePlaceholder: "Your full name",
    phoneLabel: "Phone number", phonePlaceholder: "05xx xxx xx xx",
    phoneHint: "Enter your phone correctly for the WhatsApp confirmation message.",
    phoneWarning: "Phone number must be 11 digits. Enter your phone correctly for the WhatsApp confirmation.",
    back: "Back", next: "Continue", confirm: "Confirm Booking",
    successTitle: "Booking Confirmed!", successWaiting: "is looking forward to seeing you.",
    nameRow: "Full name", locationLabel: "Location", directions: "Get Directions (Google Maps)",
    manageBooking: "Manage My Booking (Cancel / Reschedule)", confirmSms: "A confirmation message will be sent to your phone.",
    newBooking: "New Booking", demoCta: "Back to Home & Sign Up",
    poweredBy: "Powered by 365Rez — start free today",
    demoBanner: "This is a demo booking page", demoBannerShort: "Demo page",
    home: "Home", register: "Sign Up",
    notAvailableTitle: "Bookings unavailable right now",
    notAvailableDesc: "This business is not accepting online bookings at the moment. Please try again later.",
    notFoundTitle: "Business not found", notFoundDesc: "This booking link may be invalid.",
    phoneToast: "Phone number must be 11 digits.",
    manageTitle: "Your Booking", manageNotFound: "Booking not found",
    manageNotFoundDesc: "This link may be invalid or expired.",
    statusPending: "Pending", statusConfirmed: "Confirmed", statusCompleted: "Completed", statusCancelled: "Cancelled",
    cancelledNote: "This booking has been cancelled.", pastNote: "Past bookings cannot be changed.",
    pickNewDate: "Pick a new date", pickTimeSuffix: "— pick a time", noSlotsManage: "No available times for this date.",
    giveUp: "Back", doReschedule: "Reschedule", startReschedule: "Reschedule Booking", cancelBooking: "Cancel Booking",
    cancelTitle: "Do you want to cancel your booking?",
    cancelDesc: "This action cannot be undone. A cancelled booking cannot be reactivated; you will need to create a new booking.",
    cancelYes: "Yes, Cancel It", cancelToast: "Your booking has been cancelled", rescheduleToast: "Your booking has been rescheduled",
    motto: "7 Days 24 Hours 365 Days Booking",
    otpTitle: "Verify your phone", otpDesc: "Enter the 6-digit code we sent via WhatsApp:",
    otpVerify: "Verify & Continue", otpResend: "Resend code", otpCancel: "Cancel",
    otpSent: "Verification code sent via WhatsApp",
  },
  de: {
    stepService: "Leistung", stepStaff: "Mitarbeiter", stepDate: "Datum", stepTime: "Uhrzeit", stepInfo: "Daten",
    chooseService: "Leistung wählen", noServices: "Dieses Unternehmen hat noch keine Leistungen hinzugefügt.", min: "Min.",
    chooseStaff: "Mitarbeiter wählen", anyStaff: "Egal", anyStaffDesc: "Erster verfügbarer Mitarbeiter",
    chooseDate: "Datum wählen", chooseTime: "Uhrzeit wählen",
    noSlots: "Für dieses Datum sind keine Zeiten verfügbar. Bitte wählen Sie ein anderes Datum.",
    yourInfo: "Ihre Daten", serviceLabel: "Leistung", staffLabel: "Mitarbeiter", dateLabel: "Datum",
    timeLabel: "Uhrzeit", priceLabel: "Preis",
    nameLabel: "Vor- und Nachname", namePlaceholder: "Ihr vollständiger Name",
    phoneLabel: "Telefonnummer", phonePlaceholder: "05xx xxx xx xx",
    phoneHint: "Geben Sie Ihre Nummer korrekt ein — die WhatsApp-Bestätigung kommt auf diese Nummer.",
    phoneWarning: "Die Telefonnummer muss 11 Ziffern haben. Bitte korrekt eingeben — die WhatsApp-Bestätigung kommt auf diese Nummer.",
    back: "Zurück", next: "Weiter", confirm: "Termin bestätigen",
    successTitle: "Termin bestätigt!", successWaiting: "freut sich auf Sie.",
    nameRow: "Name", locationLabel: "Standort", directions: "Route planen (Google Maps)",
    manageBooking: "Meinen Termin verwalten (stornieren / verschieben)", confirmSms: "Eine Bestätigung wird an Ihr Telefon gesendet.",
    newBooking: "Neuer Termin", demoCta: "Zur Startseite & registrieren",
    poweredBy: "Powered by 365Rez — jetzt kostenlos starten",
    demoBanner: "Dies ist eine Demo-Terminseite", demoBannerShort: "Demo-Seite",
    home: "Startseite", register: "Registrieren",
    notAvailableTitle: "Termine derzeit nicht möglich",
    notAvailableDesc: "Dieses Unternehmen nimmt derzeit keine Online-Termine an. Bitte versuchen Sie es später erneut.",
    notFoundTitle: "Unternehmen nicht gefunden", notFoundDesc: "Dieser Terminlink ist möglicherweise ungültig.",
    phoneToast: "Die Telefonnummer muss 11 Ziffern haben.",
    manageTitle: "Ihr Termin", manageNotFound: "Termin nicht gefunden",
    manageNotFoundDesc: "Dieser Link ist möglicherweise ungültig oder abgelaufen.",
    statusPending: "Ausstehend", statusConfirmed: "Bestätigt", statusCompleted: "Abgeschlossen", statusCancelled: "Storniert",
    cancelledNote: "Dieser Termin wurde storniert.", pastNote: "Vergangene Termine können nicht geändert werden.",
    pickNewDate: "Neues Datum wählen", pickTimeSuffix: "— Uhrzeit wählen", noSlotsManage: "Für dieses Datum sind keine Zeiten verfügbar.",
    giveUp: "Zurück", doReschedule: "Verschieben", startReschedule: "Termin verschieben", cancelBooking: "Termin stornieren",
    cancelTitle: "Möchten Sie Ihren Termin wirklich stornieren?",
    cancelDesc: "Diese Aktion kann nicht rückgängig gemacht werden. Ein stornierter Termin kann nicht reaktiviert werden; Sie müssen einen neuen Termin buchen.",
    cancelYes: "Ja, stornieren", cancelToast: "Ihr Termin wurde storniert", rescheduleToast: "Ihr Termin wurde verschoben",
    motto: "Terminbuchung 7 Tage 24 Stunden 365 Tage",
    otpTitle: "Bestätigen Sie Ihre Nummer", otpDesc: "Geben Sie den 6-stelligen Code ein, den wir per WhatsApp gesendet haben:",
    otpVerify: "Bestätigen & Fortfahren", otpResend: "Code erneut senden", otpCancel: "Abbrechen",
    otpSent: "Bestätigungscode per WhatsApp gesendet",
  },
};

const FlagTR = () => (
  <svg viewBox="0 0 30 20" className="w-full h-full" aria-hidden="true">
    <rect width="30" height="20" fill="#E30A17" />
    <circle cx="10.8" cy="10" r="5.1" fill="#fff" />
    <circle cx="12.2" cy="10" r="4.1" fill="#E30A17" />
    <polygon
      points="20.8,6.7 21.86,8.7 24.1,9.03 22.48,10.61 22.86,12.84 20.8,11.78 18.74,12.84 19.12,10.61 17.5,9.03 19.74,8.7"
      fill="#fff"
    />
  </svg>
);
const FlagGB = () => (
  <svg viewBox="0 0 30 20" className="w-full h-full" aria-hidden="true">
    <rect width="30" height="20" fill="#012169" />
    <path d="M0,0 L30,20 M30,0 L0,20" stroke="#fff" strokeWidth="4" />
    <path d="M0,0 L30,20 M30,0 L0,20" stroke="#C8102E" strokeWidth="1.6" />
    <path d="M15,0 V20 M0,10 H30" stroke="#fff" strokeWidth="6.5" />
    <path d="M15,0 V20 M0,10 H30" stroke="#C8102E" strokeWidth="3.5" />
  </svg>
);
const FlagDE = () => (
  <svg viewBox="0 0 30 20" className="w-full h-full" aria-hidden="true">
    <rect width="30" height="6.67" fill="#000" />
    <rect y="6.67" width="30" height="6.67" fill="#DD0000" />
    <rect y="13.33" width="30" height="6.67" fill="#FFCE00" />
  </svg>
);

const LANGS = [
  { code: "tr", label: "Türkçe", Flag: FlagTR },
  { code: "en", label: "English", Flag: FlagGB },
  { code: "de", label: "Deutsch", Flag: FlagDE },
];

export function LangFlags({ lang, onChange, dark = false }) {
  return (
    <div className="flex items-center gap-1.5" data-testid="lang-flags">
      {LANGS.map(({ code, label, Flag }) => (
        <button key={code} type="button" onClick={() => onChange(code)} aria-label={label} title={label}
          data-testid={`lang-${code}`}
          className={cn("w-8 h-6 rounded overflow-hidden transition-all duration-200 ring-offset-0",
            lang === code ? "ring-2 ring-primary scale-110" : "opacity-60 hover:opacity-100 hover:scale-105",
            dark && lang === code && "ring-white")}>
          <Flag />
        </button>
      ))}
    </div>
  );
}
